import React from 'react'

const Right = props => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <path
      fill={props.fill || '#1A344F'}
      d="M5.067 12.487L9.553 8 5.067 3.513a.663.663 0 010-.946.666.666 0 01.933 0l4.893 4.9a.752.752 0 010 1.066L6 13.433a.664.664 0 11-.933-.946z"
    />
  </svg>
)

export default Right
